module.exports = __webpack_public_path__ + "static/img/3_1_3_3.4ef5c9cb.jpg";